import { isEmpty } from 'lodash-es'

const UNLOCKED_ROUTE_NAMES = [
  'accounts-account_id-subscription',
  'accounts-account_id-subscription-payment_billing',
  'accounts-account_id-users',
  'my_profile-details',
  'accounts',
]
const LOCKED_STATES = ['paused', 'cancelled']
const GLEANIN_EVENT_ROUTE_NAME = 'events-event_id-gleanin'

export default async function ({ store, route, redirect, $find, $auth }) {
  // If user is not authenticated, skip this middleware
  // Let the auth middleware handle the redirect
  if (!$auth.loggedIn) {
    return
  }

  let account = false
  const { params } = route

  try {
    if (!isEmpty(params.account_id)) {
      account = await $find('accounts', params.account_id, {
        params: { include: 'subscription' },
      })
    } else if (!isEmpty(params.event_id)) {
      const event = await $find('events', params.event_id)

      // An event built in Gleanin can't be edited in Classic, so every route of it lands on the
      // page that says so. That page is exempt, or the redirect would loop.
      if (
        event.compatible_version === 'v3' &&
        route.name !== GLEANIN_EVENT_ROUTE_NAME
      ) {
        return redirect(`/events/${params.event_id}/gleanin`)
      }

      account = await $find('accounts', event.account_id, {
        params: { include: 'subscription' },
      })
    }
  } catch {
    return
  }

  if (account) {
    store.dispatch('app/setCurrentAccount', account)

    const subscription = account.subscription
    if (!store.state.auth.user.is_internal && subscription) {
      if (
        !UNLOCKED_ROUTE_NAMES.includes(route.name) &&
        LOCKED_STATES.includes(subscription.status)
      ) {
        store.dispatch(
          'app/showAlert',
          'Sorry. This account subscription is not active.'
        )
        return redirect(`/accounts/${account._meta.id}/subscription`)
      }
    }
  }
}
